import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';
import { environment } from '../environments/environment';

// Determine default route based on specialty intake feature flag
const defaultRoute = environment.features.specialtyIntakeEnabled ? 'auth/auto-sso' : 'auth/pcv-signin';

const routes: Routes = [
  {
    path: '',
    redirectTo: defaultRoute,
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./components/modules/authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/modules/admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: 'specialist',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/modules/specialist/specialist.module').then(m => m.SpecialistModule),
  },
  {
    path: 'pcv',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/modules/pcv/pcv.module').then(m => m.PcvModule),
  },
  {
    path: '**',
    redirectTo: defaultRoute
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }